import {createSelector} from 'reselect'
import {getReportsState} from '../../selectors'

const getCreateReportPopupState = createSelector(
    getReportsState,
    (reports) => reports.dashboard.createReportPopup
)

export const getSelectedTab = createSelector(
    getCreateReportPopupState,
    (createReportPopup) => createReportPopup.tab
)


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/selectors.js